import { Invoice } from "../../SharedModule/types/shared-module-types";

const projectsBaseUrl = process.env.REACT_APP_ASUITE_PROJECT_URI;
const workOrderBaseUrl = process.env.REACT_APP_ASUITE_WO_URI;

export const getBillingGroupUrl = (invoice: Invoice): string => {
  const { type, externalId } = invoice.billingGroup;
  const baseUrl = type.id === 1 ? projectsBaseUrl : workOrderBaseUrl;
  return `${baseUrl}${externalId}`;
};
